export default "__VITE_ASSET__e6bd09b1__"